import react from "react";
import Request from "../../../../api/Requests";

const getDashboard = (params) => {
    
    return Request('admin/dashboard', 'GET', params, true);
}



export default {
    getDashboard
}